export enum KITCHEN_ACTION_TYPES {
    FETCH_KITCHEN_START  = 'kitchen/FETCH_KITCHEN_START',
    FETCH_KITCHEN_SUCCESS    = 'kitchen/FETCH_KITCHEN_SUCCESS',
    FETCH_KITCHEN_FAILED = 'kitchen/FETCH_KITCHEN_FAILED',
    SET_ONLINE_ORDERS_CONFIGS = 'kitchen/SET_ONLINE_ORDERS_CONFIGS'
}

export type SurchargeConfig = {
    enabled: boolean;
    value: number;
}

export type OnlineOrdersConfigs = {
    cardFeePercent: number;
    cardFeeFixedCharge: number;
    publicHolidaySurcharge?: SurchargeConfig;
    saturdaySurcharge?: SurchargeConfig;
    sundaySurcharge?: SurchargeConfig;
    surchargeConfigs?: {
        publicHolidaySurcharge?: SurchargeConfig;
        saturdaySurcharge?: SurchargeConfig;
        sundaySurcharge?: SurchargeConfig;
    };
    takeAwayEnabled: boolean;
    dineInEnabled: boolean;
    deliveryEnabled?: boolean;
    tyroLocationId: string;
    isTyroLocationIdValid: boolean;
    orderReadyTime: string;
    onlineOrderingPaused: boolean;
    /** When true during delivery hours, delivery orders are temporarily paused. */
    onlineDeliveryPaused?: boolean;
    bannerImageURL: string;
    logoURL: string;
    facebookURL: string;
    instagramURL: string;
    colorPalette: ColorPaletteType;
    customerCreationEnabled?: boolean;
    menuItemCardLayout?: "default" | "square";
}

export type ColorPaletteType = {
    "brand-font-style": string;
    "header-modal-background": string;
    "card-background": string;
    "background-secondary": string;
    "text-body": string;
    "field-border": string;
    "field-placeholder-text": string;
    "field-filled-text": string;
    "brand-tertiary": string;
    "primary-button-text": string;
    "background-tertiary": string;
    "brand-accent": string;
    "background-primary": string;
    "secondary-font-style": string;
    "brand-primary": string;
    "field-background": string;
}

export type VariantSelected = {
    charge: string;
    extraCharge: boolean;
    id: string;
    option: string;
    optionCategory: string;
}

export type DishPromo = {
    days?: string[];
    startTime?: string;
    endTime?: string;
    hideOutsideWindow?: boolean;
    featureDuringPromo?: boolean;
}

export type Dishes = {
  categoryId: any;
  id: string;
  category: string;
  imageUrl: string;
  dishDescription: string;
  dishName: string;
  dishPrice: number;
  dishPriceWithVariants: number;
  remoteUri: string;
  variantSelected: VariantSelected[];
  cartItemId: string;
  dishStatus: string;
  isDishAvailableOnline: boolean;
  isBundle?: boolean;
  isSplit?: boolean;
  bundleConfig?: {
    isSplit?: boolean;
    Steps?: any[];
    steps?: any[];
  };
  bundleParentId?: string;
  bundleTemplateId?: string;
  bundleSignature?: string;
  bundleStepId?: string;
  bundleStepName?: string;
  priceAdjustment?: number;
  allocatedPrice?: number;
  allocatedPriceWithVariants?: number;
  promo?: DishPromo;
};

export type DeliveryFee = {
  feeAmount?: string;
  type?: string;
};

export type DeliveryConfig = {
  maxDistance?: number | string;
  fee?: DeliveryFee;
  /** Minimum lead time in minutes for delivery orders. */
  deliveryMinimumTime?: string | number;
};

export type Kitchen = {
    abn: any;
    email: any;
    phoneNumber: any;
    kitchenPushToken: any;
    kitchenId: any;
    tyro_location_id: any;
    orderWaitTime: any;
    hours: any;
    /** IANA timezone of the venue (e.g. "Australia/Perth"). Falls back to DEFAULT_KITCHEN_TIMEZONE. */
    timezone?: string;
    /** Same shape as `hours.schedule`: array of `{ [DayName]: { from, to, from2?, to2? } }`. */
    deliverySchedule?: any[];
    /** Present when delivery is enabled; includes maxDistance and fee. */
    deliveryConfig?: DeliveryConfig | null;
    kitchenName: any;
    id: string;
    kitchenSlug: string;
    imageUrl: string;
    fullAddress: string;
    cuisine: string[];
    dishes: Dishes[];
    dishCategories: DishCategory[]
}

export type DishCategory = {
    name: string,
    id: string,
    categoryNumber: number
}

export type DishesMap = {
    [key: string]: Dishes[]
}
